namespace Roodik.Core
{
	export interface ISource
	{
		name : string;
		url : string;
	}
	
	export class ResourceProvider
	{
		private _source : Array<ISource> = new Array<ISource>();

		constructor(name ?: string, url ?: string)
		{
			if (name != null || url!=null)
			{
				this.add(name, url);
			}
		}
		
		public add(name : string, url : string)
		{
			this._source.push(<ISource>{
				name:name,
				url:url
			});
		}
		
		public get sourceList()
		{
			return this._source;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Resources/ResourceProvider.ts